import { ScrollArea } from "@/core/components/ui/scroll-area";
import { Stack } from "@/core/components/ui/stack";
import { Typography } from "@/core/components/ui/typography";
import {
  DetailCloseButton,
  DetailSidebarFallback,
  StatusBadge,
} from "@/accounts-payable/common";
import { useGetInvoice } from "@/accounts-payable/query";
import { invoiceStatusMeta } from "@/accounts-payable/utils";
import { InvoiceDetailBody } from "./invoice-detail-body";

export const ApInvoiceDetail = ({
  invoiceId,
  businessId,
  onClose,
  onViewAgentReview,
}: {
  invoiceId: string;
  businessId: string | null;
  onClose: () => void;
  onViewAgentReview?: (invoiceId: string) => void;
}) => {
  const { data: invoice, isPending } = useGetInvoice(businessId, invoiceId);

  if (!invoice) {
    return (
      <DetailSidebarFallback
        loading={isPending}
        errorMessage="Couldn’t load the invoice. Please try again."
        onClose={onClose}
      />
    );
  }

  return (
    <Stack gap="none" fullWidth className="h-full">
      {/* Header */}
      <Stack
        gap="sm"
        fullWidth
        className="flex-none border-b border-stroke-tertiary bg-bg-secondary/50 p-6"
      >
        <Stack
          direction="row"
          justify="between"
          align="start"
          gap="md"
          fullWidth
        >
          <Stack direction="row" gap="sm" align="center" className="flex-wrap">
            <StatusBadge meta={invoiceStatusMeta(invoice)} />
            <Typography textColor="tertiary">
              {invoice.invoice_number}
            </Typography>
          </Stack>
          <DetailCloseButton onClose={onClose} />
        </Stack>
        <Typography variant="subtitleW1">{invoice.vendor_name}</Typography>
      </Stack>

      {/* Body */}
      <ScrollArea className="min-h-0 w-full flex-1">
        <InvoiceDetailBody
          invoice={invoice}
          businessId={businessId}
          onViewAgentReview={(id) => {
            onClose();
            onViewAgentReview?.(id);
          }}
        />
      </ScrollArea>
    </Stack>
  );
};
